export default {
    pre_cart_total: '',
    pre_cart_itens: '',
    cart:{}
}